export const SET_USER = "SET_USER"; // login or register
export const UNSET_USER = "UNSET_USER"; // logout